import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet';
import 'leaflet/dist/leaflet.css'

import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { useMemo, useRef, useState } from 'react';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

L.Marker.prototype.options.icon = DefaultIcon;

export const Map = ({data,handleChange}:any) => {
    const center = {
        lat: data.lat,
        lng: data.lng,
    }
    const [position, setPosition] = useState(center)

    function DraggableMarker() {
        // const [draggable, setDraggable] = useState(false)
        const markerRef = useRef(null)
        const eventHandlers = useMemo(
            () => ({
                dragend() {
                    const marker:any = markerRef.current
                    if (marker != null) {
                        setPosition(marker.getLatLng())
                        handleChange((prev:any) => 
                            ({ ...prev, 'location': {lat: marker.getLatLng().lat, lng:marker.getLatLng().lng} }))
                    }
                },
            }),
            [],
        )
        // const toggleDraggable = useCallback(() => {
        //     setDraggable((d) => !d)
        // }, [])
        
        return (
            <Marker
                draggable={true}
                eventHandlers={eventHandlers}
                position={position}
                ref={markerRef}>
                <Popup minWidth={90}>
                    <span >
                        انتخاب لوکیشن
                    </span>
                </Popup>
            </Marker>
        )
    }
    return (
        <div className="map">
            <p className='text-bg-primary p-2 rounded'>با تغییر مکان نشانگر موقعیت خود را در نقشه انتخاب نمایید.</p>
            <div id="google-maps" style={{width: "100%" ,height: "100%",overflow: "hidden"}}>
            <MapContainer center={center} zoom={13} scrollWheelZoom={false} style={{ width: "100%", height: "100vh" }}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <DraggableMarker />
            </MapContainer>
            </div>
        </div>
    )
}